/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Injectable } from '@angular/core';
import { ResourceInterface } from '@app/shared/models/resource.interface';
import { HttpClient } from '@angular/common/http';
import { ApiQuery } from '@app/core/http/api-query';
import { Observable } from 'rxjs';
import { PaginatedResponse } from '@app/shared/models/paginated-response.model';
import { map } from 'rxjs/operators';
import { HttpResponse } from '@app/core';
import { Venue } from '@app/settings/venues/venue.model';
import { Model } from '@app/shared/models/model.model';

@Injectable({
  providedIn: 'root',
})
export class VenuesService implements ResourceInterface {
  constructor(private http: HttpClient) {}

  index(query: ApiQuery = new ApiQuery()): Observable<PaginatedResponse> {
    return this.http.get('v1/venues', query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        response.data = response.data.map((venue: Venue) => {
          return new Venue().deserialize(venue);
        });
        return new PaginatedResponse().deserialize(response);
      })
    );
  }

  update(venue: Venue): Observable<Venue> {
    return this.http.put('v1/venues/' + venue.id, venue).pipe(
      map((response: HttpResponse) => {
        return new Venue().deserialize(response.data);
      })
    );
  }

  store(venue: Venue): Observable<Venue> {
    return this.http.post('v1/venues', venue).pipe(
      map((response: HttpResponse) => {
        return new Venue().deserialize(response.data);
      })
    );
  }

  show(id: number, query: ApiQuery = new ApiQuery()): Observable<Model> {
    return this.http.get('v1/venues/' + id, query.buildGetOptions()).pipe(
      map((response: HttpResponse) => {
        return new Venue().deserialize(response.data);
      })
    );
  }

  destroy(id: number): Observable<any> {
    return this.http.delete('v1/venues/' + id);
  }

  updateTranslations(venue: Venue, translations: any): Observable<any> {
    return this.http.put('v1/venues/translations/' + venue.id, translations).pipe(
      map((response: HttpResponse) => {
        return response;
      })
    );
  }
}
